<template>
  <AttachmentPreviewContainer
    type="Attachment"
    :title="attachment.data.caption"
    @remove="$emit('remove')"
  >
    <div class="h-16 w-16 rounded-md flex-shrink-0 overflow-hidden">
      <img :src="preview" class="h-full w-full">
    </div>
  </AttachmentPreviewContainer>
</template>

<script setup lang="ts">
import AttachmentPreviewContainer from '../../preview/Container.vue'

interface Props {
  attachment: Record<string, any>
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'remove'): void
}>()

const preview = computed(() => {
  return props.attachment?.data?.file ? URL.createObjectURL(props.attachment?.data?.file) : props.attachment?.data?.imageUrls?.square
})
</script>
